import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LiveFunctionComponent } from './liveFunction.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [LiveFunctionComponent]
})
export class LiveFunctionModule { }
